import React, { PureComponent, ReactNode } from 'react';

class ErrorBoundary extends PureComponent {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    hasError: false,
  };

  static getDerivedStateFromError(error: Error): { hasError: boolean; error: Error } {
    return { hasError: true, error };
  }

  renderFallback = (): ReactNode => <div>Произошла ошибка</div>;

  render(): ReactNode {
    const { children } = this.props;
    const { hasError } = this.state;

    return hasError ? this.renderFallback() : children;
  }
}

export default ErrorBoundary;
